import api from './api';

const API_PREFIX = '/customer';

const getCustomer = ({ id }) => api.get(`${API_PREFIX}/${id}`);

const getInviteCustomerUrl = (
  {
    customerId,
    email,
    isNew = false,
  }) => api.get(`${API_PREFIX}/${customerId}/users/invite/url`,
  {
    params: {
      email,
      isNew,
    },
  });

const resendInvitation = ({ customerId, emails }) =>
  api.post(`${API_PREFIX}/${customerId}/users/invite/resend`, {
    emails: emails.map(email => ({ email })),
  });

const inviteCustomer = ({ firstName, lastName, email, customerId }) =>
  api.post(`${API_PREFIX}/${customerId}/users/invite`, {
    firstName,
    lastName,
    email,
  });
const addCompany = ({ companyName }) =>
  api.post('/customer', {
    companyName,
  });

const editCompanyName = ({ companyName, id }) =>
  api.put(`/customer/${id}`, {
    companyName,
  });

const setupAccount = ({ token, password, firstName, lastName }) =>
  api.post(`${API_PREFIX}/setupAccount`, {
    token,
    password,
    fName: firstName,
    lName: lastName,
  });

const acceptInvitation = ({ customerId }) =>
  api.post(`${API_PREFIX}/${customerId}/acceptInvitation`);

const getInvitations = ({ page, limit, customerId }) =>
  api.get(`${API_PREFIX}/${customerId}/invitations`, {
    params: {
      Page: page,
      Limit: limit,
    },
  });

const getUsers = ({ customerId, page, limit }) =>
  api.get(`${API_PREFIX}/${customerId}/users`, {
    params: {
      Page: page,
      Limit: limit,
    },
  });

export const getCustomers = ({
  page,
  limit,
  search,
  subscriptionStatus,
  exceedingDeviceCount,
  sortColumn,
  sortDesc,
}) => {
  // Built with URLSearchParams (not the plain object below) so a multi-value filter is sent as
  // repeated keys - `SubscriptionStatus=A&SubscriptionStatus=B` - which is the one query-string
  // shape ASP.NET Core's [FromQuery] List<T> binding always understands. Axios's own array
  // serialization defaults to `SubscriptionStatus[]=A&SubscriptionStatus[]=B`, which that binder
  // does not recognize, and a single comma-joined value isn't reliably split into list items either.
  const params = new URLSearchParams();

  // Unlike axios's plain params object (which silently drops undefined entries), URLSearchParams
  // stringifies whatever it's given - `.set('Page', undefined)` becomes the literal "?Page=undefined"
  // on the wire. Several callers (login's initial company lookup, the sidebar's unfiltered customer
  // count) don't pass page/limit/sort at all and rely on the backend's own defaults, so every field
  // here has to be skipped rather than set when absent.
  if (page != null) {
    params.set('Page', page);
  }
  if (limit != null) {
    params.set('Limit', limit);
  }
  if (search) {
    params.set('Search', search);
  }
  (subscriptionStatus || []).forEach(status => params.append('SubscriptionStatus', status));
  if (exceedingDeviceCount) {
    params.set('ExceedingDeviceCount', exceedingDeviceCount);
  }
  if (sortColumn) {
    params.set('SortBy', sortColumn);
    params.set('Order', sortDesc ? 'DESC' : 'ASC');
  }

  return api.get(`${API_PREFIX}/customers`, { params });
};

export const getCustomerEnvironments = ({ customerId, page, limit }) =>
  api.get(`${API_PREFIX}/${customerId}/environments`, {
    params: {
      Page: page,
      Limit: limit,
    },
  });

export const validateInvitation = ({ token }) =>
  api.post(`${API_PREFIX}/invitation/validate`, {
    token,
  });

const getCompanyMembers = ({ customerId, page, limit }) =>
  api.get(`${API_PREFIX}/${customerId}/companyMembers`, {
    params: {
      Page: page,
      Limit: limit,
    },
  });

const CustomerService = {
  getCompanyMembers,
  getInvitations,
  getUsers,
  getCustomers,
  getCustomerEnvironments,
  getCustomer,
  getInviteCustomerUrl,
  editCompanyName,
  resendInvitation,
  inviteCustomer,
  setupAccount,
  acceptInvitation,
  addCompany,
  validateInvitation,
};

export default CustomerService;
